import React from "react";
import { Form, InputGroup } from "react-bootstrap";
import search from "../../../../../assets/img/searchicon.png";
import InputMask from "react-input-mask";
import { handleKeyPress, handleWheel } from "../gridFunctions";
import { DbkField } from "../Elements/DbkField";
import { DATA_ENTRY, EDIT_WORK, QA_REVIEW, isActiveDbkField } from "../../../../../functions";
import moment from "moment";
import PaginateSection from "../../../../components/PaginateSection";
import PlbPaginatedModal from "../../../../components/PlbPaginatedModal";

const Lite = (props) => {
  const {
    formik,

    setPayeeLiteFocus,
    payeeLiteFocus,
    // DBK
    totalPages,

    jobData,
    isPayerPage,
    isPayeePage,
    pdfLoaded,
    isViewOnllyGrid,
    job_id,
    log_id,
    plbPaginatedata,
    setPlbPaginateData,
    handlePlbPageChange,
    handlePlbPaginatedCurrentPage
  } = props;



  const pathname = window.location.pathname;
  const gridData = jobData?.grid_data;
  const qaCorrectedData = gridData?.qa_corrected_data;
  const renderClass = (name, type, defaultClass) => {
    if (formik.errors?.[name]) {
      return defaultClass + ' error-field'
    }
    if (pathname == QA_REVIEW) {

      if (qaCorrectedData &&
        qaCorrectedData?.[name]) {
        return defaultClass + ' qa-field'
      }
      else if (type == 'DATE' && moment(formik.values?.[name]).format("MM/DD/YYYY") != moment(gridData?.[name]).format("MM/DD/YYYY")) {
        return defaultClass + ' qa-field'
      }
      else if (type == 'TEXT' && formik.values?.[name]?.toUpperCase() !=
        gridData?.[name]?.toUpperCase()) {
        return defaultClass + ' qa-field'
      }
      else if (type == 'NUMBER' && parseFloat(formik.values?.[name] ? formik.values?.[name] : 0).toFixed(2) !=
        parseFloat(gridData?.[name] ?
          gridData?.[name] : 0).toFixed(2)) {
        return defaultClass + ' qa-field'
      }

      else if (gridData?.transaction_type != "PAYMENT835_LITE") {
        return defaultClass + ' qa-field'
      }
      else {
        return defaultClass;
      }


    }
    else if ((pathname == EDIT_WORK + job_id || pathname == EDIT_WORK + job_id + "?log_id=" + log_id) &&
      qaCorrectedData &&
      qaCorrectedData?.[name]) {
      return defaultClass + ' qa-field'
    }
    else {
      return defaultClass;
    }
  }
  const renderPlbClass = (name, type, defaultClass, index) => {
    if (formik.errors?.plb_adjustments &&
      formik.errors?.plb_adjustments[index] &&
      formik.errors?.plb_adjustments[index]?.[name]) {
      return defaultClass + ' error-field'
    }
    if (pathname == QA_REVIEW) {

      if (qaCorrectedData &&
        qaCorrectedData?.plb_adjustments &&
        qaCorrectedData?.plb_adjustments[index] &&
        qaCorrectedData?.plb_adjustments[index]?.[name]) {
        return defaultClass + ' qa-field'
      }
      else if (type == 'DATE' &&
        gridData?.plb_adjustments &&
        gridData?.plb_adjustments[index] &&
        moment(formik.values?.plb_adjustments[index]?.[name]).format("MM/DD/YYYY") != moment(gridData?.plb_adjustments[index]?.[name]).format("MM/DD/YYYY")) {
        return defaultClass + ' qa-field'
      }
      else if (type == 'TEXT' &&
        gridData?.plb_adjustments &&
        gridData?.plb_adjustments[index] &&
        formik.values?.plb_adjustments[index]?.[name]?.toUpperCase() !=
        gridData?.plb_adjustments[index]?.[name]?.toUpperCase()) {
        return defaultClass + ' qa-field'
      }
      else if (type == 'STRING' &&
        gridData?.plb_adjustments &&
        gridData?.plb_adjustments[index] &&
        formik.values?.plb_adjustments[index]?.[name] !=
        gridData?.plb_adjustments[index]?.[name]) {
        return defaultClass + ' qa-field'
      }
      else if (type == 'NUMBER' &&
        gridData?.plb_adjustments &&
        gridData?.plb_adjustments[index] &&
        parseFloat(formik.values?.plb_adjustments[index]?.[name] ? formik.values?.plb_adjustments[index]?.[name] : 0).toFixed(2) !=
        parseFloat(gridData?.plb_adjustments[index]?.[name] ?
          gridData?.plb_adjustments[index]?.[name] : 0).toFixed(2)) {
        return defaultClass + ' qa-field'
      }
      else if (gridData?.plb_adjustments &&
        !gridData?.plb_adjustments[index]) {
        return defaultClass + ' qa-field'
      }

      else if (gridData?.transaction_type != "PAYMENT835_LITE") {
        return defaultClass + ' qa-field'
      }
      else {
        return defaultClass;
      }


    }
    else if ((pathname == EDIT_WORK + job_id || pathname == EDIT_WORK + job_id + "?log_id=" + log_id) &&
      qaCorrectedData &&
      qaCorrectedData?.plb_adjustments &&
      qaCorrectedData?.plb_adjustments[index] &&
      qaCorrectedData?.plb_adjustments[index]?.[name]) {
      return defaultClass + ' qa-field'
    }
    else {
      return defaultClass;
    }
  }

  return (
    <React.Fragment>
      <div
        className="topblock-wrapper eoblite_block accordion-collapse collapse show"
        id="collapseOne"
        aria-labelledby="headingOne"
        data-bs-parent="#payment835"
      >
        <div className="sub-section">
          <div className="">
            <label className="btn btn-payment835">Payment835 Lite</label>
          </div>
          <div className="paymentmethod-wi">
            <InputGroup>
              <InputGroup.Text>Payment Method</InputGroup.Text>
              <Form.Control
                as="select"
                name="payment_method"
                onChange={formik.handleChange}
                value={formik.values?.payment_method}
                className={renderClass('payment_method', 'TEXT', 'selc-bg-1')}


              >
                <option value="0">Select an Option</option>
                <option value="ACH">ACH</option>
                <option
                  value="CHK"
                  selected={formik.values?.check_amount > parseFloat(0)}
                >
                  CHK
                </option>
                <option
                  value="NON"
                  selected={formik.values?.check_amount == parseFloat(0)}
                >
                  NON
                </option>
                <option
                  value="VCP"
                >
                  VCP
                </option>
              </Form.Control>
            </InputGroup>
          </div>
          <div className="checknum-wi">
            <InputGroup>
              <InputGroup.Text>Check Number</InputGroup.Text>
              <div className="dbk-main-container">
                <Form.Control
                  type="text"
                  className={renderClass('check_number', 'TEXT', 'w-78')}

                  name="check_number"
                  value={formik.values?.check_number}


                />


              </div>
            </InputGroup>
          </div>
          <div className="checkdate-wi">
            <InputGroup>
              <InputGroup.Text>Check Date</InputGroup.Text>
              <div className="dbk-main-container">
                <InputMask
                  mask="99/99/9999"
                  className={renderClass('check_date', 'DATE', 'w-48')}

                  style={{ fontSize: "0.7em" }}

                  value={formik.values?.check_date}
                  name="check_date"
                  placeholder={"mm/dd/yyyy"}

                />


              </div>
            </InputGroup>
          </div>
          <div className="checkamt-wi">
            <InputGroup>
              <InputGroup.Text>Check Amount</InputGroup.Text>
              <div className="dbk-main-container">
                <Form.Control
                  type="number"
                  value={formik.values?.check_amount}
                  className={renderClass('check_amount', 'NUMBER', 'w-78')}

                  name="check_amount"
                  pattern={/[0-9]+([\.][0-9]{2})?/}

                />



              </div>
            </InputGroup>
          </div>
          <div className="remainingbln-wi">
            <InputGroup>
              <InputGroup.Text>Remaining Balance</InputGroup.Text>
              <Form.Control
                type="number"


                value={formik.values?.remaining_balance}

                className={
                  "w-78 text-end"
                }
                name="check_amount"
                pattern={/[0-9]+([\.][0-9]{2})?/}
              />

            </InputGroup>
          </div>
        </div>

        <div className="sub-section">
          <div className="">
            <label className="btn btn-payer">Payer </label>
          </div>
          <div className="wrapper-payer">
            <InputGroup>
              <InputGroup.Text>
                Name{" "}
                <a
                  type="button"
                  className="payersearch"
                >
                  <img src={search} alt="" />
                </a>
                {/* Check View Pop-Up */}
              </InputGroup.Text>
              <div className="dbk-main-container">
                <Form.Control
                  type="text"

                  value={formik.values?.payer_name}

                  className={renderClass('payer_name', 'TEXT', 'w-payer text-uppercase')}

                  name="payer_name"

                />


              </div>
            </InputGroup>
          </div>
          {console.log(formik.errors)}
          {isPayerPage &&
            <div className='pagefrom-corress'>
              <div className="input-group">
                <label className="input-group-text">
                  Page From
                </label>
                <Form.Control
                  className={renderClass('payer_page_from', 'NUMBER', 'pagefrom')}

                  min={1}
                  type="number"
                  value={formik.values?.payer_page_from}
                  name="payer_page_from"
                />
              </div>
            </div>
          }
          {isPayerPage &&

            <div className='pageto-corress'>
              <div className="input-group">
                <label className="input-group-text">
                  Page To
                </label>
                <Form.Control
                  data-disabled={!pdfLoaded}
                  className={renderClass('payer_page_to', 'NUMBER', 'pageto')}

                  min={1}
                  type="number"
                  value={formik.values?.payer_page_to}
                  name={"payer_page_to"}
                />
              </div>
            </div>
          }

        </div>
        <div className="master-bottom-section">
          <div className="sub-section">
            <div className="">
              <label className="btn btn-payer">Payee </label>
            </div>
            <div className="wrapper-payer">
              <InputGroup>
                <InputGroup.Text>
                  Name{" "}
                  <a className="payersearch">
                    <img
                      src={search}
                      alt=""
                    />
                  </a>
                </InputGroup.Text>
                <div className="dbk-main-container">

                  <Form.Control
                    type="text"
                    className={renderClass('payee_name', 'TEXT', 'w-payer')}

                    onBlur={() => setPayeeLiteFocus(false)}
                    autoFocus={payeeLiteFocus}
                    value={formik.values?.payee_name}

                    name="payee_name"

                  />



                </div>
              </InputGroup>
            </div>
            {console.log(isViewOnllyGrid, 'isViewOnllyGridisViewOnllyGrid')}
            {isPayeePage &&

              <div className='pagefrom-corress'>
                <div className="input-group">
                  <label className="input-group-text">
                    Page From
                  </label>
                  <Form.Control
                    className={renderClass('payee_page_from', 'NUMBER', 'pagefrom')}

                    min={1}
                    type="number"
                    value={formik.values?.payee_page_from}
                    name={`payee_page_from`}

                  />
                </div>
              </div>
            }
            {isPayeePage &&

              <div className='pageto-corress'>
                <div className="input-group">
                  <label className="input-group-text">
                    Page To
                  </label>
                  <Form.Control
                    className={renderClass('payee_page_to', 'NUMBER', 'pageto')}

                    min={1}
                    type="number"
                    value={formik.values?.payee_page_to}
                    name={`payee_page_to`}

                  />
                </div>
              </div>
            }
            {formik?.values?.plb_adjustments?.length>plbPaginatedata?.pageSize&&
              <div className="plb-pgination-container-section">
                <PaginateSection handlePlbPageChange={handlePlbPageChange} plbPaginatedata={plbPaginatedata} data={formik?.values?.plb_adjustments} />
              </div>
            }
          </div>
        </div>
        <React.Fragment>
            <PlbPaginatedModal handlePlbPageChange={handlePlbPageChange} handlePlbPaginatedCurrentPage={handlePlbPaginatedCurrentPage} componentType='PAYMENT835LITE' plbPaginatedata={plbPaginatedata} setPlbPaginateData={setPlbPaginateData} formik={formik} handleWheel={handleWheel} renderPlbClass={renderPlbClass} handleKeyPress={handleKeyPress} isViewOnllyGrid={isViewOnllyGrid} totalPages ={totalPages}/>
        </React.Fragment>
      </div>
    </React.Fragment>
  );
};

export default Lite;
